import {AuthHttp} from 'angular2-jwt/angular2-jwt';
import { Injectable } from '@angular/core';
import { UtilsService } from './utils.service';
import { ProjectService } from './project.service';
import { TagService } from './tag.service';


import { Observable }  from 'rxjs/Observable';
import './rxjs-operators';

@Injectable()
export class ArcService {
  serviceUrl: string;
  userNs: string;
  app = 'rating';
  utils: UtilsService;
  projects: ProjectService;
  tags: TagService;


  constructor(
    private http: AuthHttp
  ) {
    this.serviceUrl = `${location.protocol}//gae-test.ecomole.com/a2`;
  }

  communicate(type: string, payload: Object): Observable<any> {
    if (!this.userNs) {
      this.userNs = JSON.parse(localStorage.getItem('auth_profile'))['user_id'];
      console.log(112233, this.userNs);
    }

    return this.http.post(this.serviceUrl,
      JSON.stringify({
        payload: payload,
        type: type,
        app: this.app,
        u: this.userNs,
        email: this.utils.email
      })).map((res) => res.json());
    //      })).map((res) => payload['isDownload'] ? res.text() : res.json())
  }

  run(payload: Object): Observable<any> {
    console.log('RUN', payload);
    return this.communicate('run', payload);
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/arc.service.ts